// components
import { SettingsValueProps } from '@mymeeinc/shared-web/components/settings/type';
import { Projects } from '@mymeeinc/types/config';
import { UserTypes } from '@mymeeinc/types/user';

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  projectName: 'Mymee Member Panel',
  environmentPrefix: import.meta.env.MODE !== 'production' ? '[' + import.meta.env.MODE + '] ' : '',
  project: Projects.MEMBER,
  appUserType: UserTypes.MEMBER,
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'blue', // 'default' | 'purple' | 'cyan' | 'blue' | 'orange' | 'red';
  themeStretch: false,
};
